// SEARCH PAGE DATA TEMP CONSTANTS
export const SEARCH_SORT_OPTIONS = {
    STANDARD_BEST_RESULTS: '',
    PRICE_ASCENDING: '&sortField=lang_neutral.price_currentSalesPrice&sortDirection=asc',
    PRICE_DESCENDING: '&sortField=lang_neutral.price_currentSalesPrice&sortDirection=desc',
    // {PP} is replaced with the RATE filter's paybackPeriod (default 60) by resolveSortQuery
    // — the per-duration fields are lang_neutral.rate_monthlyInstallment{12..72} (ADV-205).
    RATE_ASCENDING: '&sortField=lang_neutral.rate_monthlyInstallment{PP}&sortDirection=asc',
    RATE_DESCENDING: '&sortField=lang_neutral.rate_monthlyInstallment{PP}&sortDirection=desc',
    NEWEST_OFFERS_FIRST: '&sortField=dates.metaData_creationDate&sortDirection=desc',
    MILEAGE_ASCENDING: '&sortField=lang_neutral.mainData_mileage&sortDirection=asc',
    MILEAGE_DESCENDING: '&sortField=lang_neutral.mainData_mileage&sortDirection=desc',
    POWER_ASCENDING: '&sortField=lang_neutral.engineData_powerPS&sortDirection=asc',
    POWER_DESCENDING: '&sortField=lang_neutral.engineData_powerPS&sortDirection=desc',
    FIRST_REGISTRATION_ASCENDING: '&sortField=dates.mainData_firstRegistration&sortDirection=asc',
    FIRST_REGISTRATION_DESCENDING: '&sortField=dates.mainData_firstRegistration&sortDirection=desc'
};
export const SUPER_ADMIN_SEARCH_SORT_OPTIONS = {
    PREDICTED_VS_CURRENT_PRICE_ASCENDING: '&sortField=lang_neutral.price_mlCurrentSalesPriceDiffPercent&sortDirection=asc',
    PREDICTED_VS_CURRENT_PRICE_DESCENDING: '&sortField=lang_neutral.price_mlCurrentSalesPriceDiffPercent&sortDirection=desc'
};
export const FAVORITES_SORT_OPTIONS = [
    'SORT_FAVORITES_STAANDARD',
    'SORT_FAVORITES_PRICE_INCREASE',
    'SORT_FAVORITES_PRICE_DECREAASE',
    'SORT_FAVORITES_NEWEST_FIRST',
    'SORT_FAVORITES_NEWEST_LAST',
    'SORT_FAVORITES_MILLEAGE_INCREASE',
    'SORT_FAVORITES_MILLEAGE_DECREASE',
    'SORT_FAVORITES_POWER_INCREASE',
    'SORT_FAVORITES_POWER_DECREASE',
    'SORT_FAVORITES_FIRST_REGISTRATION_INCREASE',
    'SORT_FAVORITES_FIRST_REGISTRATION_DECREASE',
    'SORT_FAVORITES_DISTANCE_DECREASE'
];
export const FAVORITES_SORT_DEFAULT = 'SORT_FAVORITES_STAANDARD';
export const MY_VEHICLES_SORT_OPTIONS = [
    'NewestFirst',
    'OldestFirst',
    'HighestPriceFirst',
    'LowestPriceFirst',
    'ActiveFirst',
    'InactiveFirst',
    'PowerAscending',
    'PowerDescending'
];
export const MY_VEHICLES_SORT_DEFAULT = '';
